import React from 'react';

export function Logo({ className = '', size = 'default' }) {
    const sizes = {
        small: { width: 120, height: 32 },
        default: { width: 150, height: 40 },
        large: { width: 200, height: 52 }
    };
    
    const { width, height } = sizes[size] || sizes.default;
    
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 150 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            {/* Circuit/Digital Icon */}
            <g>
                {/* Hexagon shape */}
                <path
                    d="M12 4L22 10V22L12 28L2 22V10L12 4Z"
                    fill="currentColor"
                    className="text-primary"
                />
                {/* Inner X pattern */}
                <path
                    d="M8 11L12 16L8 21M16 11L12 16L16 21"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                {/* Connection dots */}
                <circle cx="12" cy="16" r="2" fill="white" />
            </g>
            
            {/* XDigital Text */}
            <text
                x="30"
                y="24"
                fontFamily="Manrope, sans-serif"
                fontWeight="700"
                fontSize="18"
                fill="currentColor"
            >
                <tspan className="text-primary">X</tspan>
                <tspan className="text-foreground">Digital</tspan>
            </text>
            
            {/* Tagline */}
            <text
                x="30"
                y="36"
                fontFamily="Plus Jakarta Sans, sans-serif"
                fontWeight="400"
                fontSize="7"
                fill="currentColor"
                className="text-muted-foreground"
            >
                IT CONSULTANCY
            </text>
        </svg>
    );
}

export function LogoIcon({ className = '', size = 32 }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M16 2L28 9V23L16 30L4 23V9L16 2Z"
                fill="currentColor"
                className="text-primary"
            />
            <path
                d="M11 12L16 18L11 24M21 12L16 18L21 24"
                stroke="white"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx="16" cy="18" r="2.5" fill="white" />
        </svg>
    );
}
